import { apiFetch } from "@/lib/api";
import { SKU_HOVER_HINTS_QUERY_MAX } from "@integrator-src/mrp/sku-hover-hints";
import type { MrpForecastSourcingCpnSummary } from "@/lib/mrp";

export const MRP_FORECAST_SOURCING_QUERY_ROOT = ["mrp", "forecast-sourcing"] as const;

/** Stable React Query key for a batch of grid CPNs (sorted, comma-joined). */
export function mrpForecastSourcingQueryKey(cpnsQueryParam: string): readonly [string, string, string] {
  return [...MRP_FORECAST_SOURCING_QUERY_ROOT, cpnsQueryParam];
}

function chunkCpns(cpns: readonly string[]): string[][] {
  const chunks: string[][] = [];
  for (let index = 0; index < cpns.length; index += SKU_HOVER_HINTS_QUERY_MAX) {
    chunks.push(cpns.slice(index, index + SKU_HOVER_HINTS_QUERY_MAX));
  }
  return chunks;
}

export async function fetchMrpForecastSourcingByCpns(
  cpns: readonly string[],
): Promise<Record<string, MrpForecastSourcingCpnSummary>> {
  const distinct = [...new Set(cpns.map((cpn) => cpn.trim()).filter(Boolean))].sort((left, right) =>
    left.localeCompare(right),
  );
  if (distinct.length === 0) {
    return {};
  }
  const merged: Record<string, MrpForecastSourcingCpnSummary> = {};
  for (const chunk of chunkCpns(distinct)) {
    const response = await apiFetch<{ forecast_sourcing_by_cpn: Record<string, MrpForecastSourcingCpnSummary> }>(
      "/api/mrp/forecast/sourcing",
      { query: { cpns: chunk.join(",") } },
    );
    Object.assign(merged, response.forecast_sourcing_by_cpn);
  }
  return merged;
}

export function mrpForecastGridCpnsQueryParam(cpns: readonly string[]): string {
  return [...new Set(cpns.map((cpn) => cpn.trim()).filter(Boolean))]
    .sort((left, right) => left.localeCompare(right))
    .join(",");
}
